import React from 'react'
import PagesLayout from '..'

export default function FamiliesPage() {
  return (
    <PagesLayout
      title="Famílias"
      description="A KFamily promove o apoio ajudando famílias e empresas a enviar facilmente mensagens de simpatia, fortalecendo os laços em momentos difíceis."
    >
      <br />
      <br />
      <br />
      Em desenvolvimento.
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </PagesLayout>
  )
}
